var map = {
	"./AnnouncementsWidget.vue": "a457",
	"./ArticleListWidget.vue": "fc05",
	"./BaseWidgetForm.vue": "306b",
	"./CalendarWidget.vue": "2aac",
	"./ColumnTextWidget.vue": "b9d3",
	"./EventTilesWidget.vue": "29ef",
	"./FaqWithHeaderWidget.vue": "5c88",
	"./FilesWidget.vue": "ab1b",
	"./GalleryWidget.vue": "c474",
	"./ImageWidget.vue": "a62d",
	"./ImageWithTextWidget.vue": "994d",
	"./NewsletterWidget.vue": "d8f8",
	"./PeopleListWidget.vue": "108b",
	"./SliderWidget.vue": "1d41",
	"./SpectacleListWidget.vue": "191d",
	"./SubmenuWidget.vue": "3788",
	"./TextWidget.vue": "ce64",
	"./TextWithTitleWidget.vue": "8aba",
	"./TilesWidget.vue": "03a4",
	"./UpcomingEventsWidget.vue": "b08b",
	"./VideoWidget.vue": "733b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e1";